import { P2GGrid } from '@parcel2go/core-ui';

import { SvgSquareArrowLeft } from '@parcel2go/core-ui';
import { SvgClose } from '@parcel2go/core-ui';
import { P2GText } from '@parcel2go/core-ui';
import { P2GBox } from '@parcel2go/core-ui';
import { CurrentSelectionType } from '../utils/CurrentSelectionType';
import { QuoteProviderAccountApiModel } from '~/lib/api/smartsend/types';
import { TruncateString } from '../../../../lib/helpers/StringHelper';
import { P2GMyAccountHeader } from '~/components/header';
import CdnIconProxy from '~/apps/account-linking/components/CdnIconProxy';

interface props {
  onBack: () => void;
  currentSelection: CurrentSelectionType;
  selectedServiceProvider: QuoteProviderAccountApiModel;
  multiAccount: boolean;
  title: string;
  isXs: boolean;
  children?: React.ReactNode;
}

export const QuoteLayoutHeader: React.FC<props> = (props) => {
  return (
    <>
      <P2GGrid container alignItems="center" spacing={3}>
        <P2GGrid item flexGrow={1}>
          <P2GMyAccountHeader
            variant="quote"
            title={props.title}
            isXs={props.isXs}
            hasSidePanel={false}
            backControl={
              <CdnIconProxy
                src={props.isXs && props.multiAccount ? '/theme/icons/SquareArrowLeft.svg' : '/theme/icons/Close.svg'}
                palette="primary"
                size="sm"
                onClick={props.onBack}
              >
                {props.isXs && props.multiAccount ? <SvgSquareArrowLeft /> : <SvgClose />}
              </CdnIconProxy>
            }
          />
        </P2GGrid>
        {!props.isXs && props.currentSelection?.marketplaceService && (
          <P2GGrid item flexShrink={1}>
            <P2GBox textAlign="center" bordered pt={1} pr={3} pb={1} pl={3}>
              <P2GText variant="body2">
                <small>Your recipient chose</small>
                <br />
                <strong>{TruncateString(props.currentSelection?.marketplaceService, 20)}</strong>
              </P2GText>
            </P2GBox>
          </P2GGrid>
        )}
      </P2GGrid>
      {props.children}
    </>
  );
};
